import React from 'react';
import SEOHead from '../../components/SEOHead';

const BlogIndex = () => {
  const posts = [
    {
      title: "AI Receptionists for Home Service Businesses: The Complete Guide to 24/7 Growth",
      slug: "ai-receptionists-home-services",
      excerpt: "Learn how home service companies across all trades use AI receptionists to capture leads, handle emergencies, and grow revenue with 24/7 professional customer support.",
      date: "July 26, 2025",
      readTime: "15 min read",
      category: "Home Services"
    },
    {
      title: "AI Receptionists for HVAC Companies: Never Miss Another Emergency Call",
      slug: "ai-receptionists-hvac-companies",
      excerpt: "Discover how HVAC companies use AI receptionists to capture emergency calls 24/7, track high-value service opportunities, and provide immediate customer support during heating and cooling crises.",
      date: "June 20, 2025",
      readTime: "10 min read",
      category: "HVAC Services"
    },
    {
      title: "AI Receptionists for Plumbing Services: Turn Every Emergency Into Revenue",
      slug: "ai-receptionists-plumbing-services",
      excerpt: "Learn how plumbing companies use AI receptionists to capture urgent pipe bursts, sewer backups, and water emergencies 24/7 while maximizing revenue per call.",
      date: "June 21, 2025",
      readTime: "11 min read",
      category: "Plumbing Services"
    },
    {
      title: "AI Receptionists for Electrical Contractors: Safety First, Revenue Always",
      slug: "ai-receptionists-electrical-contractors",
      excerpt: "Learn how electrical contractors use AI receptionists to handle urgent electrical emergencies, safety concerns, and high-value commercial projects 24/7.",
      date: "June 22, 2025",
      readTime: "12 min read",
      category: "Electrical Services"
    },
    {
      title: "AI Receptionists for Medical Practices: Better Patient Care, Higher Revenue",
      slug: "ai-receptionists-medical-practices",
      excerpt: "Learn how medical practices use AI receptionists to provide 24/7 patient support, handle appointment scheduling, and maintain HIPAA compliance while reducing costs.",
      date: "June 23, 2025",
      readTime: "13 min read",
      category: "Healthcare"
    },
    {
      title: "AI Receptionists for Real Estate: Never Miss a Lead, Always Close More Deals",
      slug: "ai-receptionists-real-estate",
      excerpt: "Learn how real estate agents and agencies use AI receptionists to capture leads 24/7, qualify prospects instantly, and provide immediate property information to serious buyers.",
      date: "June 24, 2025",
      readTime: "11 min read",
      category: "Real Estate"
    },
    {
      title: "AI Receptionists for Auto Repair Shops: Keep Customers Rolling, Revenue Growing",
      slug: "ai-receptionists-auto-repair",
      excerpt: "Learn how auto repair shops use AI receptionists to handle emergency breakdowns, schedule maintenance, and provide instant service estimates 24/7.",
      date: "June 25, 2025",
      readTime: "10 min read",
      category: "Automotive Services"
    },
    {
      title: "Why Every Law Firm Needs an AI Receptionist in 2025",
      slug: "ai-receptionists-law-firms",
      excerpt: "Discover how AI receptionists transform law firm operations with client memory, revenue tracking, and 24/7 availability. Learn why leading firms are making the switch.",
      date: "May 15, 2025",
      readTime: "12 min read",
      category: "Legal Technology"
    },
    {
      title: "AI Receptionists for Personal Injury Law Firms: Capture Every Case, 24/7",
      slug: "ai-receptionists-personal-injury-law",
      excerpt: "Learn how personal injury law firms use AI receptionists to never miss urgent calls, track case values, and provide immediate support to injured clients seeking help.",
      date: "May 16, 2025",
      readTime: "10 min read",
      category: "Personal Injury Law"
    },
    {
      title: "AI Receptionists for Family Law: Compassionate Support During Life's Hardest Moments",
      slug: "ai-receptionists-family-law",
      excerpt: "Discover how family law practices use AI receptionists to provide 24/7 emotional support, handle emergency custody situations, and maintain client confidentiality.",
      date: "May 17, 2025",
      readTime: "11 min read",
      category: "Family Law"
    },
    {
      title: "AI Receptionists for Criminal Defense: 24/7 Crisis Response When Freedom Is at Stake",
      slug: "ai-receptionists-criminal-defense",
      excerpt: "Learn how criminal defense attorneys use AI receptionists to handle urgent arrest calls, maintain attorney-client privilege, and provide immediate support when clients need it most.",
      date: "May 18, 2025",
      readTime: "12 min read",
      category: "Criminal Defense"
    },
    {
      title: "AI Receptionists for Estate Planning: Building Trust While Growing Your Practice",
      slug: "ai-receptionists-estate-planning",
      excerpt: "Discover how estate planning attorneys use AI receptionists to provide compassionate support, track high-value clients, and ensure sensitive family matters are handled with care 24/7.",
      date: "May 19, 2025",
      readTime: "11 min read",
      category: "Estate Planning"
    },
    {
      title: "How AI Receptionists Are Revolutionizing Small Business Phone Systems",
      slug: "ai-receptionists-small-business",
      excerpt: "Discover how AI receptionists are helping small businesses never miss a customer call while reducing costs and improving customer service.",
      date: "March 15, 2025",
      readTime: "5 min read",
      category: "Business Technology"
    },
    {
      title: "The Complete Guide to Virtual Receptionists for Service-Based Businesses",
      slug: "virtual-receptionists-service-businesses",
      excerpt: "Learn why plumbers, electricians, and other service professionals are switching to AI receptionists for better lead capture and customer service.",
      date: "March 12, 2025",
      readTime: "8 min read",
      category: "Service Industry"
    },
    {
      title: "ROI of AI Phone Systems: How Much Can Your Business Save?",
      slug: "roi-ai-phone-systems",
      excerpt: "Break down the costs and benefits of AI phone systems vs traditional receptionists for different business sizes and industries.",
      date: "May 10, 2025",
      readTime: "6 min read",
      category: "Business Finance"
    },
    {
      title: "24/7 Customer Service: Why After-Hours Calls Matter for Your Business",
      slug: "24-7-customer-service-importance",
      excerpt: "Explore how businesses lose customers by missing after-hours calls and how AI receptionists solve this problem.",
      date: "April 8, 2025",
      readTime: "4 min read",
      category: "Customer Service"
    }
  ];

  return (
    <>
      <SEOHead
        title="AI Receptionist Blog | Business Phone System Tips & Insights"
        description="Get insights on AI receptionists, virtual phone systems, and customer service automation. Learn how to improve your business communication."
        keywords="ai receptionist blog, virtual receptionist tips, business phone system, customer service automation, small business communication"
        canonical="https://receptioneer.ai/blog"
        ogTitle="AI Receptionist Blog - Business Communication Insights"
        ogDescription="Expert insights on AI receptionists, virtual phone systems, and business communication strategies to help your business grow."
        ogImage="https://receptioneer.ai/images/blog-og.jpg"
      />
      
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="/blog" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Blog
              </a>
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Demo
              </a>
            </div>
          </div>
        </header>

        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-5xl font-black mb-6">
              AI Receptionist <span className="text-blue-200">Insights</span>
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Expert tips, case studies, and insights on AI receptionists and business communication automation.
            </p>
          </div>
        </section>

        {/* Blog Posts */}
        <section className="py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="grid gap-8">
              {posts.map((post, index) => (
                <article key={index} className="bg-white rounded-xl border border-gray-200 hover:shadow-lg transition-shadow duration-300">
                  <div className="p-8">
                    <div className="flex items-center gap-4 mb-4">
                      <span className="bg-blue-100 text-blue-900 px-3 py-1 rounded-full text-sm font-semibold">
                        {post.category}
                      </span>
                      <span className="text-gray-500 text-sm">{post.date}</span>
                      <span className="text-gray-500 text-sm">{post.readTime}</span>
                    </div>
                    
                    <h2 className="text-2xl font-bold text-gray-900 mb-4 hover:text-blue-900 transition-colors">
                      <a href={`/blog/${post.slug}`}>
                        {post.title}
                      </a>
                    </h2>
                    
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {post.excerpt}
                    </p>
                    
                    <a 
                      href={`/blog/${post.slug}`}
                      className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold"
                    >
                      Read full article →
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-blue-900 text-white py-16 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-black mb-6">
              Ready to Get Your AI Receptionist?
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Start capturing more leads and never miss another customer call.
            </p>
            <a
              href="/"
              className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 inline-block"
            >
              Get Started Today →
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/blog" className="hover:text-blue-900">Blog</a>
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BlogIndex;